import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container, useTick } from '@pixi/react';
import { useCallback, useRef } from 'react';
import { POKER_SEAT_ROUNDED_RECT_RADIUS } from '../../../../constants/constants';
import { removePlayerBubble } from '../../../../redux/actions/playerBubblesActions';
import { useAppDispatch } from '../../../../redux/store';
import { assertUnreachable } from '../../../../utils/tsUtils';
import { isTestEnvironment } from '../../../../utils/utils';
import { AlignedText } from '../../pixiComponents/alignedText';
import { Rect } from '../../pixiComponents/rect';
import { PlayerBubbleCardDisplay } from './playerBubbleCardDisplay';
const DURATION_MS = 8000;
const FADE_OUT_DURATION_MS = 1000;
export const PlayerBubbleDisplay = ({ playerBubble, playerBubbleAllProperties, x, y, w, h, textStyle }) => {
    const dispatch = useAppDispatch();
    const containerRef = useRef(null);
    const animate = useCallback(() => {
        const nowMs = performance.now();
        if (nowMs > playerBubble.performanceTimestampMs + DURATION_MS + FADE_OUT_DURATION_MS) {
            // all done
            dispatch(removePlayerBubble(playerBubble.seatIndex, playerBubble.id));
            return;
        }
        if (!containerRef.current) {
            return;
        }
        if (nowMs > playerBubble.performanceTimestampMs + DURATION_MS) {
            // fading out
            const elapsedFadeOutMs = nowMs - (playerBubble.performanceTimestampMs + DURATION_MS);
            const fadeOutRatio = Math.min(1, Math.max(0, elapsedFadeOutMs / FADE_OUT_DURATION_MS));
            const remainingFadeOutRatio = 1 - fadeOutRatio;
            containerRef.current.alpha = remainingFadeOutRatio;
        }
    }, [dispatch, playerBubble.id, playerBubble.performanceTimestampMs, playerBubble.seatIndex]);
    useTick(animate);
    const { lines } = playerBubble;
    const { lineProperties } = playerBubbleAllProperties;
    const pixiData = isTestEnvironment()
        ? { type: 'player-bubble', bubbleId: playerBubble.id, seatIndex: playerBubble.seatIndex }
        : undefined;
    return (_jsxs(Container, { x: x, y: y, ref: containerRef, children: [_jsx(Rect, { x: 0, y: 0, w: w, h: h, fillColor: 0x000000, fillAlpha: 0.5, radius: POKER_SEAT_ROUNDED_RECT_RADIUS }), lines.map((line, i) => {
                const currLineProperties = lineProperties[i];
                switch (currLineProperties.type) {
                    case 'text': {
                        return (_jsx(AlignedText, { pixiData: pixiData, x: Math.round(w / 2), y: currLineProperties.bounds.y, text: currLineProperties.text, textStyle: textStyle }, i));
                    }
                    case 'cards': {
                        return (_jsx(Container, { children: currLineProperties.cardsWithBounds.map((cardWithBounds, j) => {
                                const { card, bounds } = cardWithBounds;
                                const { x, y, w, h } = bounds;
                                return (_jsx(PlayerBubbleCardDisplay, { playerBubble: playerBubble, card: card, x: x, y: y, w: w, h: h }, j));
                            }) }, i));
                    }
                    default: {
                        assertUnreachable(currLineProperties);
                    }
                }
            })] }));
};
